import styled from "styled-components/macro";
import { Checkbox, Button } from "antd";
import { COLORS } from "../../../../layout/theme";
import TextArea from "antd/lib/input/TextArea";

export const PageWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 28px;
	padding: 10px 24px 32px;

	@media only screen and (max-width: 768px) {
		padding: 8px 12px 24px;
	}
`;

export const TopRow = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	gap: 20px;

	@media only screen and (max-width: 980px) {
		flex-direction: column;
		align-items: stretch;
	}
`;

export const TitleBlock = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const PageTitle = styled.h1`
	margin: 0;
	font-size: 30px;
	font-weight: 700;
	line-height: 1.05;
	color: #0f172a;

	@media only screen and (max-width: 768px) {
		font-size: 32px;
	}
`;

export const ActionsRow = styled.div`
	display: flex;
	gap: 16px;
	align-items: center;

	@media only screen and (max-width: 768px) {
		width: 100%;
		flex-direction: column;
	}
`;

export const SecondaryAction = styled(Button)`
	height: 94px;
	min-width: 260px;
	padding: 0 28px;
	border-radius: 16px;
	border: none;
	background: #e5e7eb;
	color: #334155;
	font-size: 18px;
	font-weight: 700;
	box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);

	&:hover,
	&:focus,
	&:active {
		background: #d1d5db !important;
		color: #1f2937 !important;
		border: none !important;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		min-width: 100%;
		height: 64px;
	}
`;

export const TerciaryAction = styled(Button)`
	height: 94px;
	min-width: 260px;
	padding: 0 28px;
	border-radius: 16px;
	border: none;
	background: ${COLORS.Danger};
	color: ${COLORS.White};
	font-size: 18px;
	font-weight: 700;
	box-shadow: 0 8px 18px rgba(15, 23, 42, 0.08);

	&:hover,
	&:focus,
	&:active {
		background: #d1d5db !important;
		color: #1f2937 !important;
		border: none !important;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		min-width: 100%;
		height: 64px;
	}
`;

export const PrimaryAction = styled(Button)`
	height: 94px;
	min-width: 300px;
	padding: 0 28px;
	border-radius: 16px;
	border: none;
	background: linear-gradient(90deg, #4f46e5 0%, #4f46e5 100%);
	color: white;
	font-size: 18px;
	font-weight: 700;
	box-shadow: 0 10px 20px rgba(79, 70, 229, 0.22);

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(90deg, #4338ca 0%, #4338ca 100%) !important;
		color: white !important;
		border: none !important;
	}

	@media only screen and (max-width: 768px) {
		width: 100%;
		min-width: 100%;
		height: 64px;
	}
`;

export const SummaryCard = styled.div`
	background: ${COLORS.White};
	border-radius: 20px;
	padding: 34px 36px;
	box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 24px;

	@media only screen and (max-width: 1100px) {
		grid-template-columns: repeat(2, 1fr);
	}

	@media only screen and (max-width: 768px) {
		grid-template-columns: 1fr;
		padding: 22px 16px;
	}
`;

export const SummaryItem = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const SummaryLabel = styled.div`
	font-size: 16px;
	font-weight: 800;
	text-transform: uppercase;
	color: #6b7280;
`;

export const SummaryValue = styled.div`
	font-size: 18px;
	font-weight: 700;
	color: #1f2937;
`;

export const StatusPill = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: fit-content;
	padding: 10px 20px;
	border-radius: 999px;
	font-size: 16px;
	font-weight: 700;
	background: ${(props) => props.bg || "#ede9fe"};
	color: ${(props) => props.color || "#4338ca"};
`;

export const SectionTitle = styled.h2`
	margin: 0;
	font-size: 30px;
	font-weight: 700;
	line-height: 1.1;
	color: #0f172a;

	@media only screen and (max-width: 768px) {
		font-size: 28px;
	}
`;

export const TableCard = styled.div`
	background: ${COLORS.White};
	border-radius: 20px;
	overflow: hidden;
	box-shadow: 0 10px 24px rgba(15, 23, 42, 0.08);
`;

export const TotalsCard = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 28px;
	padding: 22px 28px;
	border-top: 1px solid #e5e7eb;
	background: #ffffff;

	@media only screen and (max-width: 768px) {
		flex-direction: column;
		gap: 12px;
	}
`;

export const TotalItem = styled.div`
	display: flex;
	align-items: flex-end;
	gap: 8px;
`;

export const TotalLabel = styled.div`
	font-size: 16px;
	font-weight: 700;
	color: #475569;
`;

export const TotalValue = styled.div`
	font-size: 20px;
	font-weight: 800;
	color: ${(props) => props.color || "#0f172a"};
`;

export const FooterActions = styled.div`
	display: flex;
	justify-content: center;
	margin-top: 8px;
`;

export const BackButton = styled(Button)`
	height: 56px;
	min-width: 180px;
	padding: 0 24px;
	border-radius: 14px;
	border: none;
	background: linear-gradient(90deg, #4f46e5 0%, #4f46e5 100%);
	color: white;
	font-size: 16px;
	font-weight: 700;
	box-shadow: 0 8px 18px rgba(79, 70, 229, 0.22);

	&:hover,
	&:focus,
	&:active {
		background: linear-gradient(90deg, #4338ca 0%, #4338ca 100%) !important;
		color: white !important;
		border: none !important;
	}
`;

/* Mantengo exports viejos por compatibilidad si OrderTable los usa indirectamente */
export const Inner = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0;
`;

export const InnerForm = styled.div`
	display: flex;
	flex-direction: column;
	gap: 28px;
`;

export const ProductData = styled.div`
	flex: 1 1 65%;
`;

export const PublishSettings = styled.div`
	flex: 1 1 35%;
	background-color: white;
`;

export const DistributorImage = styled.img`
	width: 40px;
	height: 40px;
	object-fit: contain;
`;

export const AntdCheckbox = styled(Checkbox)``;

export const OrderData = styled.div`
	display: flex;
	flex-direction: column;
	gap: 28px;
`;

export const BlockedData = styled.div`
	pointer-events: none;
`;

export const TextAreaDetails = styled(TextArea)`
	width: 700px;
	heigth: 100%;
`;

export const LineBreak = styled.hr`
	width: 100%;
	border: none;
	margin-top: 0px;
	box-shadow: 0 1px 1px #bfbfbf;
	height: 1px;
`;

export const HeaderContainer = styled.div`
	display: none;
`;

export const TitleBanner = styled.div`
	display: none;
`;

export const TitleContainer = styled.div`
	display: none;
`;

export const SubTitleContainer = styled.div``;

export const InfoContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	align-content: center;
`;

export const InfoText = styled.div`
	display: flex;
	gap: 5px;
	align-items: center;
	color: ${COLORS.Grey};
	font-size: 14px;
	font-weight: 700;
`;

export const InfoTableContainer = styled.div`
	flex: 1 1 80%;
	height: 100%;
	width: 100%;
	overflow: hidden;
`;

export const InfoPriceContainer = styled.div`
	flex: 1 1 30%;
	background-color: white;
	border-radius: 10px;
	padding: 1rem;
	max-height: 300px;
`;

export const OptionsButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const InfoSubSection = styled.div`
	display: flex;
	justify-content: space-evenly;
	margin: 15px 0px 15px 0px;
	align-content: center;
	align-items: center;
`;

export const Divider = styled.hr`
	width: 100%;
	border: none;
	margin-top: 0px;
	margin-left: auto;
	margin-right: auto;
	height: 1px;
	background-color: ${COLORS.LightGrey};
	opacity: 1;
	box-shadow: 0 3px 3px #bfbfbf;
`;

export const InfoTitle = styled.div`
	color: ${COLORS.Secondary};
	font-size: 20px;
	font-weight: 800;
`;

export const InfoTitleTotal = styled.div`
	color: ${COLORS.Primary};
	font-size: 18px;
	font-weight: 800;
`;

export const InfoSubTitle = styled.div`
	color: ${COLORS.Grey};
	font-size: 20px;
	font-weight: 800;
`;

export const InfoIva = styled.div`
	font-size: 12px;
	text-align: right;
	color: ${COLORS.Default};
	padding: 0 28px 22px;
`;

export const PriceContainer = styled.div`
	display: flex;
	background-color: ${COLORS.White};
	border-radius: 10px;
	padding: 1rem;
	justify-content: space-evenly;
`;

export const Container = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export const ButtonContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 10px;
	flex-wrap: wrap;
`;
